import React from 'react';
import { Page } from 'containers/App';
import { LaunchpadContainer } from 'containers/Launchpad/Launchpad';

export const AdminHome = () => {
  return (
    <>
      <Page withPageHeader={false} withContentWrapper={false} />
      <LaunchpadContainer />
    </>
  );
};
